export default __webpack_public_path__ + "static/media/tvy7fv.6b96da65.png";